import script from "./LeadershipTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeadershipTeam.vue?vue&type=script&setup=true&lang=ts"

import "./LeadershipTeam.vue?vue&type=style&index=0&id=64cae7f3&lang=scss"

const __exports__ = script;

export default __exports__